<template>
  <div>
  </div>
</template>

<script>
import svgAsset from '@/assets/DisplayX1031.svg';
import state from '@/state';

const segments = [
  'relais1',
  'achtung',
  'wartung',
  'relais2',
  'hand',
  'sonne',
  'mond',
  'frost',
  'segment2h',
  'segment2g',
  'segment2o',
  'segment2d',
  'segment2a',
  'segment2i',
  'segment2n',
  'segment2m',
  'segment2b',
  'segment2k',
  'segment2l',
  'segment2c',
  'segment3f',
  'segment3e',
  'segment2f',
  'segment2e',
  'segment3h',
  'segment3g',
  'segment3o',
  'segment3d',
  'segment3a',
  'segment3i',
  'segment3n',
  'segment3m',
  'segment3b',
  'segment3k',
  'segment3l',
  'segment3c',
  'segment0h',
  'segment0g',
  'segment0o',
  'segment0d',
  'segment0a',
  'segment0i',
  'segment0n',
  'segment0m',
  'segment0b',
  'segment0k',
  'segment0l',
  'segment0c',
  'segment1f',
  'segment1e',
  'segment0f',
  'segment0e',
  'segment1h',
  'segment1g',
  'segment1o',
  'segment1d',
  'segment1a',
  'segment1i',
  'segment1n',
  'segment1m',
  'segment1b',
  'segment1k',
  'segment1l',
  'segment1c',
  'segment4f',
  'segment4g',
  'segment4e',
  'segment4d',
  'segment4a',
  'segment4b',
  'segment4c',
  'minus1',
  'segment5f',
  'segment5g',
  'segment5e',
  'segment5d',
  'segment5a',
  'segment5b',
  'segment5c',
  'dp5',
  'segment6f',
  'segment6g',
  'segment6e',
  'segment6d',
  'segment6a',
  'segment6b',
  'segment6c',
  'p5',
  'segment7f',
  'segment7g',
  'segment7e',
  'segment7d',
  'segment7a',
  'segment7b',
  'segment7c',
  'p6',
  'segment8f',
  'segment8g',
  'segment8e',
  'segment8d',
  'segment8a',
  'segment8b',
  'segment8c',
  'minus2',
  'segment9f',
  'segment9g',
  'segment9e',
  'segment9d',
  'segment9a',
  'segment9b',
  'segment9c',
  'dp9',
  'segment10f',
  'segment10g',
  'segment10e',
  'segment10d',
  'segment10a',
  'segment10b',
  'segment10c',
  'p9',
  'segment11f',
  'segment11g',
  'segment11e',
  'segment11d',
  'segment11a',
  'segment11b',
  'segment11c',
  'p10',
];

export default {
  props: [
    'bridge',
    'displayBuffer',
  ],

  watch: {
    displayBuffer() {
      // console.log('display', this.displayBuffer);

      const activeClass = 'rs-x1031-active';
      const inactiveClass = 'rs-x1031-inactive';

      for (let i = 0; i < segments.length; i++) {
        const segment = segments [i];
        if (segment) {
          const offset = i >> 3;
          const mask = 1 << (i & 7);
          const state = !!(this.displayBuffer [offset] & mask);
          const elements = this.$el.querySelectorAll(`.rs-x1031-${segment}`);
          if (elements.length === 0) {
            throw new Error(`Unable to find segment ${segment}`);
          }
          for (const element of elements) {
            if (state) {
              if (element.classList.contains(inactiveClass)) {
                element.classList.remove(inactiveClass);
              }
              if (!element.classList.contains(activeClass)) {
                element.classList.add(activeClass);
              }
            } else {
              if (element.classList.contains(activeClass)) {
                element.classList.remove(activeClass);
              }
              if (!element.classList.contains(inactiveClass)) {
                element.classList.add(inactiveClass);
              }
            }
          }
        }
      }
    }
  },

  methods: {
    getDisplaySvg() {
      return this.$el.innerHTML;
    },
  },

  mounted() {
    state.runAsync(async () => {
      const httpResponse = await fetch(svgAsset);
      if (!httpResponse.ok) {
        throw new Error('Unable to fetch display SVG');
      }

      const svgString = await httpResponse.text();

      this.$el.innerHTML = svgString;

      const svgEl = this.$el.querySelector('svg');
      // svgEl.setAttribute('viewBox', '70.7 85.4 71.7 38.6');
      svgEl.setAttribute('width', '100%');
      svgEl.setAttribute('height', '100%');

      // for testing purposes only
      // console.log(segments.length);
      // for (const segment of segments) {
      //   const elems = svgEl.querySelectorAll(`.rs-x1031-${segment}`);
      //   if (elems.length === 0) {
      //     throw new Error(`Unknown segment ${segment}`);
      //   }
      // }
    });
  }
};
</script>

<style>

</style>
